export default {
  precision: 'Precisão'
}
